{
	"backLinkTitle": "Tillbaka till Hantera deklarationer",
	"invoicedQuantity": "Fakturerad kvantitet",
	"remainingForDeclarationCreation": "Återstår för skapande av deklaration",
	"nonTransferableAmount": "Ej allokerbar mängd",
	"btnCreateDeclaration": "+ Skapa deklaration",
	"errorMessage": "Det gick inte att ladda materialdetaljer"
}
